<template>
  <div>
    <!-- <h2 class="title mb-3">
      Account Information
      <svg-icon :icon="`pencil`" class="icon-xs ml-2" />
    </h2> -->
    <b-form>
      <!-- <b-form-group :label="`${$t('login')}:`" label-for="login">
        <b-form-input
          id="login"
          type="text"
          required
          :placeholder="`${$t('enterLogin')}:`"
        />
      </b-form-group> -->
      <b-form-group>
        <b-form-label
          slot="label"
          :label="$t('firstName')"
          for="firstName"
          :errors="errors.firstName"
        />
        <b-form-input
          id="firstName"
          type="text"
          required
          v-model="newProfileData.firstName"
          :placeholder="`${$t('firstName')}:`"
          :state="errors.firstName ? false : null"
        />
      </b-form-group>
      <b-form-group>
        <b-form-label
          slot="label"
          :label="$t('lastName')"
          for="lastName"
          :errors="errors.lastName"
        />
        <b-form-input
          id="lastName"
          type="text"
          required
          v-model="newProfileData.lastName"
          :placeholder="$t('lastName') + ':'"
          :state="errors.lastName ? false : null"
        />
      </b-form-group>
      <b-form-group :label="$t('enterEmail') + ':'" label-for="email">
        <b-form-input
          id="email"
          type="text"
          required
          disabled
          :value="newProfileData.email"
          :placeholder="$t('enterEmail') + ':'"
        />
      </b-form-group>
      <b-form-group :label="$t('roles') + ':'">
        <multi-select
          :btn-label="$t('roles') + ':'"
          size="lg"
          :options="{ multi: true }"
          v-model="selectedRolesList"
          :select-options="roles"
        />
      </b-form-group>
      <input-password
        v-if="!passwordChanging"
        key="password"
        :label="$t('password') + ':'"
        id="password-change"
        value=""
        :placeholder="$t('changePassword')"
        :password-toggle="false"
        disabled
      >
        <div slot="label">
          <label
            for="password-change"
            class="col-form-label pt-0 d-inline-block"
          >
            {{ $t('password') }} |
          </label>
          <button
            type="button"
            @click.stop="passwordChanging = true"
            class="btn btn-link ml-1 p-0 border-0 position-relative"
          >
            <span class="small">{{ $t('changePassword') }}</span>
          </button>
        </div>
      </input-password>
      <template v-if="passwordChanging">
        <input-password
          key="old-password"
          :label="$t('password') + ':'"
          id="old-password"
          v-model="passwordChange.oldPassword"
          :placeholder="$t('enterPassword')"
          required
          :state="errors.oldPassword ? false : null"
        >
          <div slot="label">
            <label
              for="password-change"
              class="col-form-label pt-0 d-inline-block"
            >
              {{ $t('password') }} |
            </label>
            <button
              type="button"
              @click.stop="passwordChanging = false"
              class="btn btn-link p-0 ml-1 border-0 position-relative"
            >
              <span class="small">{{ $t('cancel') }}</span>
            </button>
            <span v-if="errors.oldPassword" class="text-danger error-text">
              - {{ errors.oldPassword }}
            </span>
          </div>
        </input-password>
        <input-password
          key="password"
          :label="$t('newPassword') + ':'"
          id="password"
          v-model="passwordChange.newPassword"
          :placeholder="$t('enterNewPassword')"
          required
          :strength-check="true"
          :state="errors.newPassword ? false : null"
          @password-security="setPasswordSecurity"
        >
          <div slot="label">
            <label for="password" class="col-form-label pt-0">
              {{ $t('newPassword') }}:
            </label>
            <span v-if="errors.newPassword" class="text-danger error-text">
              - {{ errors.newPassword }}
            </span>
          </div>
        </input-password>
        <input-password
          key="password-repeat"
          :label="$t('repeatPassword') + ':'"
          id="password-repeat"
          v-model="confirmNewPassword"
          @input="confirmNewPasswordError = false"
          :placeholder="$t('repeatNewPassword')"
          required
        >
          <div slot="label">
            <label for="password-repeat" class="col-form-label pt-0">
              {{ $t('repeatPassword') }}:
            </label>
            <span v-if="confirmNewPasswordError" class="text-danger error-text">
              - {{ $t('passNotSame') }}
            </span>
          </div>
        </input-password>
        <div class="text-right mb-4">
          <b-button
            size="sm"
            variant="primary"
            @click="submitPasswrodChange"
            :disabled="!strongPassword"
          >
            {{ $t('changePassword') }}
          </b-button>
        </div>
      </template>
      <b-form-group
        v-if="!hideEtherWallet"
        label="ERC20 Wallet:"
        label-for="erc20-wallet"
      >
        <input-has-icon>
          <svg-icon icon="ethereum" />
          <b-form-input
            id="erc20-wallet"
            type="text"
            required
            :placeholder="$t('enterWallet')"
          />
        </input-has-icon>
      </b-form-group>
      <b-form-group
        v-if="!hideNeoWallet"
        label="NEO-5 Wallet:"
        label-for="neo-5-wallet"
      >
        <input-has-icon>
          <svg-icon icon="neo" />
          <b-form-input
            id="neo-5-wallet"
            type="text"
            required
            :placeholder="$t('enterWallet')"
          />
        </input-has-icon>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox v-model="newProfileData.isSubscribed">
          {{ $t('subscribe') }}
        </b-form-checkbox>
      </b-form-group>
      <slot name="bottom"></slot>
    </b-form>
  </div>
</template>

<script>
import InputPassword from '@/components/Forms/InputPassword.vue';
import cloneDeep from 'clone';
import isEqual from 'js-isequal';

export default {
  props: {
    hideEtherWallet: {
      default: false,
      type: Boolean
    },
    hideNeoWallet: {
      default: false,
      type: Boolean
    },
    value: {
      default: () => ({}),
      type: Object
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    selectedRoles: {
      type: Array,
      default: () => []
    },
    allRoles: {
      type: Array,
      default: () => []
    }
  },

  components: {
    InputPassword
  },

  data() {
    return {
      strongPassword: false,
      passwordChanging: false,
      newProfileData: cloneDeep(this.value),
      passwordChange: {
        oldPassword: null,
        newPassword: null
      },
      confirmNewPassword: null,
      confirmNewPasswordError: false,
      changePasswordErrors: {},
      selectedRolesList: [],
      roles: [],
      oldRoles: []
    };
  },

  watch: {
    newProfileData: {
      deep: true,
      handler() {
        this.update();
      }
    },
    selectedRolesList: {
      deep: true,
      handler(val) {
        const userId = this.value.id;
        const roles = val.map(item => item.id);
        const data = {
          roles,
          userId
        };

        if (!isEqual(this.oldRoles, roles)) {
          this.$api.auth
            .put(`/users/roles/edit/${data.userId}`, data)
            .then(() => {
              this.$notify('alert', {
                text: this.$t('rolesSaved'),
                variant: 'success',
                time: 5000
              });
              this.oldRoles = roles;
            })
            .catch(e => {
              e.response.data.error.message &&
                this.$notify('alert', {
                  text: e.response.data.error.message || "Couldn't save roles",
                  variant: 'danger',
                  time: 5000
                });
            });
        }
      }
    },
    passwordChanging() {
      this.passwordChange = {
        oldPassword: null,
        newPassword: null
      };
      this.confirmNewPassword = null;
      this.confirmNewPasswordError = false;
    }
  },

  computed: {
    passwordChangeConfirm() {
      return this.passwordChange.newPassword === this.confirmNewPassword;
    }
  },

  methods: {
    update() {
      this.$emit('input', cloneDeep(this.newProfileData));
    },
    submitPasswrodChange() {
      if (!this.passwordChangeConfirm) {
        this.confirmNewPasswordError = true;
      } else {
        const newPassword = cloneDeep(this.passwordChange);
        newPassword.userId = this.$store.state.app.user.id;
        this.changePassword(newPassword);
      }
    },
    changePassword(newPassword) {
      this.$api.auth.post('/auth/password/change', newPassword).then(
        () => {
          this.changePasswordErrors = {};
          this.passwordChanging = false;
          this.$notify('alert', {
            text: this.$t('passwordChanged'),
            variant: 'success',
            time: 5000
          });
        },
        e => {
          this.changePasswordErrors = {};
          if (e.response.data.error.errors) {
            this.changePasswordErrors = e.response.data.error
              ? this.$parseAuthErrors(e.response.data.error.errors)
              : {};
          } else {
            e.response.data.error.message &&
              this.$notify('alert', {
                text: e.response.data.error.message,
                variant: 'danger',
                time: 5000
              });
          }
        }
      );
    },
    setPasswordSecurity({ isSecure }) {
      this.strongPassword = isSecure;
    }
  },

  created() {
    this.selectedRolesList = cloneDeep(this.selectedRoles);
    this.roles = cloneDeep(this.allRoles);
    this.oldRoles = this.selectedRolesList.map(item => item.id);
  }
};
</script>

<style lang="scss">
.error-text {
  font-weight: 600;
  font-size: 80%;
}
@include media-breakpoint-down(sm) {
  .settings-form-bottom {
    button {
      width: 100%;

      &:first-child {
        margin-top: 1.5rem;
      }
    }
  }
}
</style>
